__turbopack_context__.v({
  "actions": "ConfirmationView-module-scss-module__13uLWa__actions",
  "fieldGroup": "ConfirmationView-module-scss-module__13uLWa__fieldGroup",
  "fieldRow": "ConfirmationView-module-scss-module__13uLWa__fieldRow",
  "root": "ConfirmationView-module-scss-module__13uLWa__root",
});
